import { Provider } from 'store/api/enums';
import { Organisation } from '../models';
import {
  AddOrganisationRequestAction,
  CreateEntityGroupRequestAction,
  DeleteEntityGroupRequestAction,
  UpdateEntityGroupRequestAction,
  OrganisationState,
  SetUploadTransactionsTempAction,
  UpdateOrganisationChartOfAccountsAction,
  UpdateOrganisationDataAction,
} from '../types';
import { initialState } from './initialState';

export function handleAddOrganisationRequest(
  state: OrganisationState,
  action:
    | AddOrganisationRequestAction
    | CreateEntityGroupRequestAction
    | DeleteEntityGroupRequestAction
    | UpdateEntityGroupRequestAction
): OrganisationState {
  const addOrganisation = (action as AddOrganisationRequestAction).payload
    ?.addOrganisation;
  if (!addOrganisation) {
    return { ...state, loading: true };
  }
  const { providerName, legalName } = addOrganisation;
  const isExcelOrReceipts =
    providerName === Provider.EXCEL || providerName === Provider.RECEIPTS;
  return {
    ...state,
    loading: true,
    ...(isExcelOrReceipts && legalName
      ? {
          pendingNavigateAfterCreate: { legalName, providerName },
        }
      : {}),
  };
}

export function handleAddOrganisationFailure(
  state: OrganisationState
): OrganisationState {
  return {
    ...state,
    loading: false,
    pendingNavigateAfterCreate: undefined,
  };
}

export function handleClearPendingNavigateAfterCreate(
  state: OrganisationState
): OrganisationState {
  return {
    ...state,
    pendingNavigateAfterCreate: undefined,
  };
}

export function handleResetOrganisationData(): OrganisationState {
  return { ...initialState };
}

export function handleUpdateOrganisationData(
  state: OrganisationState,
  action: UpdateOrganisationDataAction
): OrganisationState {
  const { entityId, vatCheckerActive } = action.payload;
  let newOrgList: Organisation[] = [];
  if (state.organisations) {
    const organisations = [...state.organisations];
    const entity = organisations.find((entity) => entity.uuid == entityId);
    if (entity) {
      entity.vatCheckerActive = vatCheckerActive;
      newOrgList = organisations.filter((entity) => entity.uuid != entityId);
      newOrgList.push(entity);
    }
  }

  return {
    ...state,
    loading: false,
    organisations: newOrgList,
  };
}

export function handleUpdateOrganisationChartOfAccounts(
  state: OrganisationState,
  action: UpdateOrganisationChartOfAccountsAction
): OrganisationState {
  const { organisationId, chartOfAccounts, chartOfAccountsLoaded } =
    action.payload;
  if (!state.organisations) {
    return state;
  }

  const organisations = state.organisations.map((org) =>
    org.uuid === organisationId
      ? {
          ...org,
          chartOfAccounts,
          chartOfAccountsLoaded,
        }
      : org
  );

  return {
    ...state,
    organisations,
  };
}

export function handleSetUploadTransactionsTemp(
  state: OrganisationState,
  action: SetUploadTransactionsTempAction
): OrganisationState {
  const { file, selection } = action.payload;

  return {
    ...state,
    uploadTransactionsTemp: {
      file,
      selection,
    },
  };
}
